var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.all_reps),callback:function ($$v) {_vm.all_reps=$$v},expression:"all_reps"}}),_c('div',{attrs:{"id":"usersPaging"}}),(_vm.showModal_editRepModal)?_c('editRepModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }